"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombinedProjectGenerator = void 0;
const tslib_1 = require("tslib");
/**
 * @author zhaofengxu@microsoft.com
 */
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const lodash_1 = require("lodash");
const path_1 = tslib_1.__importDefault(require("path"));
const question_1 = require("../../../question");
const developerPortalScaffoldUtils_1 = require("../../developerPortalScaffoldUtils");
const defaultGenerator_1 = require("../defaultGenerator");
const generator_1 = require("../generator");
const templateNames_1 = require("../templates/templateNames");
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
/**
 * Generator for DA with Copilot connector.
 */
class CombinedProjectGenerator extends defaultGenerator_1.DefaultTemplateGenerator {
    componentName = "combined-project-generator";
    temporaryFolderName = "agent-temp";
    activate(context, inputs) {
        return [templateNames_1.TemplateNames.DeclarativeAgentWithGraphConnector].includes(inputs[question_1.QuestionNames.TemplateName]);
    }
    async getTemplateInfos(context, inputs, destinationPath, actionContext) {
        const auth = inputs[question_1.QuestionNames.ApiAuth];
        const appName = inputs[question_1.QuestionNames.AppName];
        const language = inputs[question_1.QuestionNames.ProgrammingLanguage];
        const safeProjectNameFromVS = language === "csharp" ? inputs[question_1.QuestionNames.SafeProjectName] : undefined;
        const solutionNameFromVS = language === "csharp" ? inputs[question_1.QuestionNames.SolutionName] : undefined;
        const replaceMap = {
            ...generator_1.Generator.getDefaultVariables(appName, safeProjectNameFromVS, solutionNameFromVS, inputs.targetFramework, inputs.placeProjectFileInSolutionDir === "true"),
            DeclarativeCopilot: "true",
            CopilotConnector: "true",
            MicrosoftEntra: auth === question_1.ApiAuthOptions.microsoftEntra().id ? "true" : "",
        };
        const templateName = inputs[question_1.QuestionNames.TemplateName];
        (0, lodash_1.merge)(actionContext?.telemetryProps, {
            ["template-name" /* telemetryProperties.templateName */]: templateName,
            ["is-microsoft-entra" /* telemetryProperties.isMicrosoftEntra */]: auth === question_1.ApiAuthOptions.microsoftEntra().id ? "true" : "",
            ["need-add-plugin-from-existing" /* telemetryProperties.needAddPluginFromExisting */]: inputs[question_1.QuestionNames.ActionType] === question_1.ActionStartOptions.existingPlugin().id.toString(),
        });
        // current template name is declarative agent with Copilot connector, no other template.
        if (templateName === templateNames_1.TemplateNames.DeclarativeAgentWithGraphConnector) {
            return Promise.resolve((0, teamsfx_api_1.ok)([
                {
                    templateName: templateNames_1.TemplateNames.GraphConnector,
                    language: question_1.ProgrammingLanguage.TS,
                    replaceMap,
                },
                {
                    templateName: templateNames_1.TemplateNames.DeclarativeAgentBasic,
                    language: question_1.ProgrammingLanguage.Common,
                    replaceMap,
                    subFolder: this.temporaryFolderName,
                },
            ]));
        }
        return Promise.resolve((0, teamsfx_api_1.ok)([
            {
                templateName,
                language: language,
                replaceMap,
            },
        ]));
    }
    // override this method to do post-step after template download
    async post(context, inputs, destinationPath, actionContext) {
        const srcFolder = path_1.default.join(destinationPath, this.temporaryFolderName, teamsfx_api_1.AppPackageFolderName);
        const targetFolder = path_1.default.join(destinationPath, teamsfx_api_1.AppPackageFolderName);
        // copy folder
        fs_extra_1.default.copySync(srcFolder, targetFolder, { overwrite: true });
        // delete folder
        fs_extra_1.default.removeSync(path_1.default.join(destinationPath, this.temporaryFolderName));
        // If coming from TDP portal, apply TDP-specific file updates (e.g. manifest patching)
        if (inputs.teamsAppFromTdp) {
            const res = await developerPortalScaffoldUtils_1.developerPortalScaffoldUtils.updateFilesForTdp(context, inputs.teamsAppFromTdp, inputs);
            if (res.isErr()) {
                return (0, teamsfx_api_1.err)(res.error);
            }
        }
        return Promise.resolve((0, teamsfx_api_1.ok)({}));
    }
}
exports.CombinedProjectGenerator = CombinedProjectGenerator;
//# sourceMappingURL=generator.js.map